import {
  Component,
  OnInit,
  QueryList,
  ViewChild,
  ViewChildren,
} from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl } from '@angular/forms';

import { Store } from '@ngrx/store';

import { SearchRequest } from '@search/interfaces/search-request.intarface';
import { ProductSearchActions } from '@search/store/search.slice';
import { FormFieldBaseComponent } from '@shared/components/form-field-base/form-field-base.component';
import { TextFieldComponent } from '@shared/components/text-field/text-field.component';

import { ProductSearchSelectors } from './../../../store/search.slice';

@Component({
  selector: 'app-price-search-subform',
  templateUrl: './price-search-subform.component.html',
  styleUrls: ['./price-search-subform.component.scss'],
})
export class PriceSearchSubformComponent implements OnInit {
  @ViewChild(FormFieldBaseComponent) child?: FormFieldBaseComponent<boolean>;
  @ViewChildren(TextFieldComponent) child2?: QueryList<
    TextFieldComponent<string>
  >;

  group = this.fb.group({});

  searchValue: SearchRequest = {};

  prevMinValue: number | null = null;
  prevMaxValue: number | null = null;

  constructor(private fb: UntypedFormBuilder, private store: Store) {}

  ngOnInit(): void {
    this.store
      .select(ProductSearchSelectors.selectSearchValue)
      .subscribe((value) => {
        this.searchValue = value;
        this.group.addControl(
          'min',
          new UntypedFormControl(value.minPrice ?? null, [])
        );
        this.group.addControl(
          'max',
          new UntypedFormControl(value.maxPrice ?? null, [])
        );
        !this.searchValue.minPrice ? this.child2?.get(0)?.clearControl() : '';
        !this.searchValue.maxPrice ? this.child2?.get(1)?.clearControl() : '';
      });
  }

  valueChanged(event: number | undefined, formControlName: string) {
    if (
      (formControlName === 'min' && this.prevMinValue !== event) ||
      (formControlName === 'max' && this.prevMaxValue !== event)
    ) {
      this.store.dispatch(
        ProductSearchActions.updateSearchValue.trigger({
          filter: {
            ...(formControlName === 'min' && {
              minPrice: event ?? undefined,
            }),
            ...(formControlName === 'max' && {
              maxPrice: event ?? undefined,
            }),
          },
        })
      );
    }
  }

  clear() {
    this.valueChanged(undefined, 'min');
    this.valueChanged(undefined, 'max');
    this.group.reset();
  }
}
